module.exports = {"id":"236221","name":"Darko Brašanac","rating":"73","photo":"./data/images/photos/1/236221.png","club":{"name":"CD Leganés","logo":"./data/images/clubs/CDLeganes.png"},"positions":["MC","MD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DarkoBrasanac0.json
// module id = 976
// module chunks = 0